import { Col, Row, Container, Form, Table } from 'react-bootstrap';
import React from 'react';

const urls = {
  Beta: {
    'eu-west-1': 'https://54.74.60.45/_plugin/kibana',
  },
  Gamma: {
    'eu-west-1': 'https://63.35.160.82/_plugin/kibana',
    'us-east-1': 'https://44.194.13.173/_plugin/kibana',
    'us-west-2': 'https://100.21.126.57/_plugin/kibana',
  },
  Prod: {
    'eu-west-1': 'https://34.247.8.182/_plugin/kibana',
    'us-east-1': 'https://54.243.163.149/_plugin/kibana',
    'us-west-2': 'https://52.39.53.44/_plugin/kibana',
  },
};

const KibanaUrls = () => {
  return (
    <Container fluid>
      <Row>
        <Col>
          <Form.Label>Kibana dashboard urls.</Form.Label>
        </Col>
      </Row>
      <Row>
        <Table className="m-3" size="sm">
          <thead hidden>
            <th>Region</th>
            <th>Url</th>
          </thead>
          <tbody>
            {Object.keys(urls).map(key => {
              const regionalUrls = urls[key];
              return (
                <>
                  <tr>
                    <td colSpan={2}>{key}</td>
                  </tr>
                  {Object.keys(regionalUrls).map(region => {
                    const url = regionalUrls[region];
                    return (
                      <tr>
                        <td>{region}</td>
                        <td>
                          <a href={url} target="_blank" rel="noopener noreferrer">
                            {url}
                          </a>
                        </td>
                      </tr>
                    );
                  })}
                </>
              );
            })}
          </tbody>
        </Table>
      </Row>
    </Container>
  );
};

export default KibanaUrls;
